/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// UTM-Parameter in Cookie speichern
(function () {
  "use strict";

  // Cookie lesen
  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  // Cookie setzen
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name + "=" + encodeURIComponent(value) + expires + "; path=/";
  }

  // Domain aus URL extrahieren
  function getDomainFromUrl(url) {
    try {
      var a = document.createElement("a");
      a.href = url;
      return a.hostname;
    } catch (e) {
      return null;
    }
  }

  // UTM-Parameter aus URL lesen
  function getUtmParams() {
    var urlParams = new URLSearchParams(window.location.search);
    var utmParams = {};
    var utmKeys = [
      "utm_id",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
    ];

    utmKeys.forEach(function (key) {
      var value = urlParams.get(key);
      if (value) {
        utmParams[key] = value;
      }
    });

    // Wenn keine UTM-Parameter vorhanden sind, Referrer prüfen
    if (Object.keys(utmParams).length === 0 && document.referrer) {
      var referrerDomain = getDomainFromUrl(document.referrer);
      var currentDomain = getDomainFromUrl(window.location.href);

      // Nur wenn Referrer vorhanden und nicht die eigene Domain
      if (referrerDomain && referrerDomain !== currentDomain) {
        utmParams.utm_source = referrerDomain;
        utmParams.utm_medium = "organic";
      }
    }

    return utmParams;
  }

  // UTM-Parameter speichern, wenn vorhanden und Cookie noch nicht gesetzt
  var existingCookie = getCookie("session_utms");
  if (!existingCookie) {
    var utmParams = getUtmParams();
    if (Object.keys(utmParams).length > 0) {
      var utmJson = JSON.stringify(utmParams);
      // Session-Cookie (wird beim Schließen des Browsers gelöscht)
      setCookie("session_utms", utmJson, null);
    }
  }
})();
